'use client';

import React from 'react';
import Image from 'next/image';

type Props = {
  gameIcon?: string;
  gameTitle?: string;
};
export default function SignInLoader({gameIcon, gameTitle}: Props) {
  return (
    <div className='grow-[3] flex flex-col gap-4'>
      <div className={'w-screen  relative text-white  justify-center px-6'}>
        <p className={'text-white text-center'}>Logging in to</p>
        <p className={'text-white text-lg text-center font-bold'}>{gameTitle}</p>
      </div>
      {gameIcon ? (
        <div
          className={'w-screen  relative text-white flex flex-col justify-center items-center px-6'}
        >
          <Image
            src={gameIcon}
            className='rounded-md'
            alt={gameTitle || 'Skillz'}
            width={90}
            height={90}
            priority={true}
          />
        </div>
      ) : null}

      <div className='w-full flex justify-center items-center'>
        <span className='w-14 inline-flex justify-between items-center mx-6'>
          <div className='h-2 w-2 bg-[#E4E4E4] rounded-full animate-[opacity_3s_ease-in-out_infinite] animation-delay-[200ms]'></div>
          <div className='h-2 w-2 bg-[#E4E4E4] rounded-full animate-[opacity_3s_ease-in-out_infinite] animation-delay-[400ms]'></div>
          <div className='h-2 w-2 bg-[#E4E4E4] rounded-full animate-[opacity_3s_ease-in-out_infinite] animation-delay-[600ms]'></div>
          <div className='h-2 w-2 bg-[#E4E4E4] rounded-full animate-[opacity_3s_ease-in-out_infinite] animation-delay-[800ms]'></div>
          <div className='h-2 w-2 bg-[#E4E4E4] rounded-full animate-[opacity_3s_ease-in-out_infinite] animation-delay-[1000ms]'></div>
        </span>
      </div>
    </div>
  );
}
